import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { ExclamationOutlined as ExclamationIcon } from '../../icons/exclamation-outlined';
import { Refresh as RefreshIcon } from '../../icons/refresh';

interface Props {
  error?: string;
  onReload?: () => void;
  sx?: SxProps;
}

const ResourceErrorRoot = styled('div')(({ theme }: { theme: Theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.neutral[100],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));

export const ResourceError = ({ error, onReload, ...other }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <ResourceErrorRoot {...other}>
      <ExclamationIcon sx={{ color: 'text.secondary' }} />
      <Typography color="textSecondary" sx={{ mt: 2 }} variant="body2">
        {error || t('common:errorLoadingData')}
      </Typography>
      {onReload && (
        <Button
          color="primary"
          onClick={onReload}
          startIcon={<RefreshIcon fontSize="small" />}
          sx={{ mt: 2 }}
          variant="text">
          {t('common:reloadData')}
        </Button>
      )}
    </ResourceErrorRoot>
  );
};
